module.exports = __webpack_public_path__ + "static/media/04.ae097d8a.jpg";